import { Link as MuiLink } from "@material-ui/core";
import { Link } from "@backstage/core-components";
import { FixLink } from "@internal/plugin-front-door-common";
import { VisuallyHidden } from "../status/VisuallyHidden";

/** An in-app fix opens in place; an external one opens in a new tab and says so. */
export function FixAnchor({ fix }: { fix: FixLink }) {
  if (fix.url.startsWith("/")) {
    return <Link to={fix.url}>{fix.title}</Link>;
  }
  return (
    <MuiLink href={fix.url} target="_blank" rel="noopener noreferrer">
      {fix.title} ↗<VisuallyHidden> (opens in a new tab)</VisuallyHidden>
    </MuiLink>
  );
}
